import React from 'react';
import { Row, Col } from 'react-bootstrap';
import phone from '../../../../../images/svg/phone.svg';
import { IMAGES } from '../../../../components/Dashboard/Content';
import { formatTimeTo12Hour } from '../../../../../utils/utils';

export const SessionDetailInfo = ({ 
    sessionDateTime, 
    sessionDuration, 
    studentName, 
    tutorName, 
    studentImage, 
    tutorImage 
}) => {
    return (
        <Row className="g-4">
            {/* Student Info */}
            <Col xs={12} md={3}>
                <h6 className="text-muted mb-2">Student</h6>
                <div className="d-flex align-items-center">
                    <img 
                        src={studentImage ? `${process.env.REACT_APP_IMAGE_PATH}${studentImage}` : IMAGES.trans2} 
                        alt="Student" 
                        className="avatar avatar-xl me-2" 
                    />
                    <span className="text-primary">{studentName || 'Student'}</span>
                </div>
            </Col>

            {/* Tutor Info */}
            <Col xs={12} md={3}>
                <h6 className="text-muted mb-2">Tutor</h6>
                <div className="d-flex align-items-center">
                    <img 
                        src={tutorImage ? `${process.env.REACT_APP_IMAGE_PATH}${tutorImage}` : IMAGES.trans2} 
                        alt="Tutor" 
                        className="avatar avatar-xl me-2" 
                    />
                    <span className="text-primary">{tutorName || 'Tutor'}</span>
                </div>
            </Col>

            {/* Scheduled Time */}
            <Col xs={12} md={3}>
                <h6 className="text-muted mb-2">Scheduled Time</h6>
                <div>
                    <i className="fa fa-calendar text-success me-2"></i>
                    {console.log("sessionDateTime = ", sessionDateTime)}
                    {/* {sessionDateTime ? sessionDateTime.format('MMM D, YYYY - h:mm A') : 'Loading...'} */}
                    {sessionDateTime ? formatTimeTo12Hour(sessionDateTime) : 'Loading...'}
                </div>
            </Col>

            {/* Session Duration */}
            <Col xs={12} md={3}>
                <h6 className="text-muted mb-2">Session Duration</h6>
                <div className="d-flex align-items-center">
                    <img src={phone} alt="Duration" className="me-2" />
                    <span>{sessionDuration}</span>
                </div>
            </Col>
        </Row>
    );
};